import request from '@webtrader/core/request';
import { EAppTheme } from '@webtrader/core/themes';

export enum EAssetType {
  CAROUSEL = 'CAROUSEL',
  CATEGORY = 'CATEGORY',
  SPLASH = 'SPLASH',
  TNC = 'TNC',
  BANNER_DEPOSIT = 'BANNER_DEPOSIT',
  BANNER_ACCOUNT_LIVE = 'BANNER_ACCOUNT_LIVE',
  BANNER_ACCOUNT_DEMO = 'BANNER_ACCOUNT_DEMO',
  FIREBASE_KEY_FILE = 'FIREBASE_KEY_FILE',
  FEATURE_ANNOUNCEMENT_CONTENT = 'FEATURE_ANNOUNCEMENT_CONTENT',
  FEATURE_ANNOUNCEMENT_ICON = 'FEATURE_ANNOUNCEMENT_ICON',
  COMPANY_ASSET = 'COMPANY_ASSET',
  PUSH_NOTIFICATION_ASSET = 'PUSH_NOTIFICATION_ASSET'
}

interface IAssetParams {
  assetType?: EAssetType;
}

export interface IAsset {
  assetPath: string;
  assetType: EAssetType;
  publishDate: number;
  sequence: number;
  url: string;
  themeColour?: EAppTheme;
}

const assets = (params?: IAssetParams) => {
  return request.get<IAsset[]>('/api/config/v1/asset', {
    params
  });
};

export default assets;
